import React from 'react';

const JS_Certificate = () => {
  return (
    <div >
      <h1>JS_Certificate</h1>
      <p>Placeholder component for: "JS Certificate"</p>
    </div>
  );
};

export default JS_Certificate;
